import React, { useState, useEffect } from 'react';
import { Card } from 'antd';
import { useQuery } from '@apollo/react-hooks';
import { Link } from 'react-router-dom';

import { queries } from '../../graphql/graphql';
import Carousel from '../Carousel/View';

import _s from './index.less';

const Recommendation = ({ plan }) => {
  const { id } = plan;
  const { data = {} } = useQuery(queries.PLAN_RECOMMENDATION, {
    variables: { id }
  });
  const { recommendation } = data;

  const [plans, setPlans] = useState([]);

  useEffect(() => {
    if (recommendation) setPlans(recommendation);
  }, [recommendation]);

  const onRecommendation = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const ListItem = ({ item }) => (
    <Link to={`/plan/${item.id}`} onClick={onRecommendation}>
      <Card
        hoverable={true}
        bordered={true}
        cover={<img src={item.image} className={_s.crop} alt="" />}
      >
        <Card.Meta
          style={{ textAlign: 'center' }}
          title={<span className={_s.title_recommendation}>{item.title.toUpperCase()}</span>}
        />
      </Card>
    </Link>
  );

  return <Carousel ListItem={ListItem} items={plans} title="Similar Homes You May Like" />;
};

export default Recommendation;
